export const customerInfoData = {
  buyer_name: '',
  buyer_type: '',
  buyer_legal_name: '',
  buyer_taxcode: '',
  buyer_address: '',
  buyer_email: '',
  buyer_phone_number: '',
  buyer_id_no: '',
  mdvqhnsach: '',
  buyer_passport_no: ''
};

export const invoiceInfoData = {
  invoice_type: '',
  template_code: '',
  invoice_number: '',
  invoice_common_code: '',
  date_created: new Date(),
  payment_method: '',
  currency_code: '',
  foreign_rate: '',
};

export const deliveryInfoData = {
  NBan_LDDNBo: '',
  NBan_PTVChuyen: '',
  NBan_HDSo: '',
  NBan_DChi: '',
  NBan_TNVChuyen: '',
  NBan_HVTNXHang: '',
};

export const additionalInfoData = {
  note_change: '',
  agreement_date: '',
  reason_change: '',
  evidence_for_change: {},
};

export const data = {
  ...customerInfoData,
  ...invoiceInfoData,
  ...deliveryInfoData,
  ...additionalInfoData,
};

export default data;



// WEBPACK FOOTER //
// ./src/portal-components/invoice/actions-invoice/form-configs/data.js